<template>
    <div class="topbar-buttons-block">
        <div class="navbar-item navbar-user" v-if="!isLoggedIn">
            <!-- login button -->
            <div v-if="loginAllowed" class="navbar-button-block">
                <router-link :to="{ name: 'login' }" class="button">
                    <span class="icon">
                        <i class="fas fa-sign-in-alt"></i>
                    </span>
                    <span>{{"components.common.topbar.login" | translate}}</span>
                </router-link>
            </div>
            <!-- registration button -->
            <div v-if="registrationAllowed" class="navbar-button-block">
                <router-link :to="{ name: 'registration' }" class="button">
                    <span class="icon">
                        <i class="fas fa-plus"></i>
                    </span>
                    <span>{{"components.common.topbar.sign up" | translate}}</span>
                </router-link>
            </div>
        </div>

        <div class="navbar-user-info" v-if="isLoggedIn">
            <router-link
                :to="{ name: 'profile', hash: '#balance' }"
                class="navbar-balance"
                active-class
            >
                <div v-if="player.balance" class="navbar-balance-inner">
                    <div class="navbar-balance-wrapper">
                        <span class="navbar-balance--balance">
                            {{ player.balance.real | currency(player.balance.currency) }}
                        </span>
                        <template v-if="player.balance.bonus > 0">
                            &#x20; / &#x20;
                            <span class="navbar-balance--bonus">
                                {{ player.balance.bonus | currency(player.balance.currency) }}
                            </span>
                        </template>
                    </div>
                </div>
                <span v-else class="navbar-balance-inner">0</span>
            </router-link>

            <router-link
                v-if="player.balance && (client.paymentSystem.paymentSystemDepositAllowed || client.paymentSystem.pinDepositAllowed)"
                class="button navbar-deposit"
                :to="{ name: 'profile', hash: '#deposit' }"
                active-class
            >{{"components.common.topbar.deposit" | translate}}</router-link>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import isMobile from 'ismobilejs';
import menuHelper from '../../../helpers/menu.helper';

export default{
    name: 'topbar-buttons-block',
    data() {
        return {
            historyRoute: null
        };
    },
    computed: {
        client() {
            return Vue.state.client.get();
        },
        loginAllowed() {
            return this.client && this.client.login.loginTypes && this.client.login.loginTypes.length;
        },
        registrationAllowed() {
            return this.client && this.client.registration.registrationTypes && this.client.registration.registrationTypes.length;
        },
        player() {
            return Vue.state.player.get();
        },
        isLoggedIn() {
            return Vue.state.player.isLoggedIn();
        }
    },
    async created() {
        await Vue.state.client.ensure();
        await Vue.state.player.ensure();
        this.loaded = true;
    },
    methods: {
        openLogout() {
            Vue.state.modals.openLogoutModal().then(
                async () => {
                    await Vue.router.teleport.home();
                },
                () => {}
            );
        }
    }
}
</script>


// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/topbar/topbar-buttons-block.vue